import React, { useState } from 'react';
import styles from '../ReportCard.module.scss';
import moment from 'moment';
import MiniMap from '../MiniMap';
import Pagination from './Pagination';
import SearchBar from './SearchBar';
import { isFarFromKaraKeche } from '../utils/geo';
import { formatDuration } from '../utils/formatDuration';

/**
 * Таблица текущих перевозок (in-route).
 */
const InRouteTableView = ({
  inRouteLoads,
  inRouteCount,
  inRouteNext,
  inRoutePrev,
  inRoutePage,
  setInRoutePage,
  inRouteSearch,
  setInRouteSearch,
  nowTime,
}) => {
  const [visibleMaps, setVisibleMaps] = useState({});
  const toggleMap = (id, geoType) => {
    const key = `${id}-${geoType}`;
    setVisibleMaps(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className={styles.table_info_wrapper}>
      <Pagination
        page={inRoutePage}
        setPage={setInRoutePage}
        count={inRouteCount}
        hasNext={!!inRouteNext}
        hasPrev={!!inRoutePrev}
        shownCount={inRouteLoads.length}
      />

      <SearchBar
        value={inRouteSearch}
        onChange={setInRouteSearch}
        onClear={() => setInRouteSearch('')}
        placeholder="Поиск по водителю, телефону, Базе, статусу, номеру машины, модели машины..."
      />

      <div className={styles.cardGridView}>
        {(Array.isArray(inRouteLoads) ? inRouteLoads : []).map((item, index) => {
          const start = item.time_a ? moment(item.time_a, 'DD.MM.YYYY HH:mm') : null;
          const diff = start ? moment.duration(nowTime.diff(start)) : null;
          const hours = diff ? Math.floor(diff.asHours()) : 0;
          const isFar = isFarFromKaraKeche(item.geo_a);
          const sequentialNumber = (inRoutePage - 1) * 10 + index + 1;
          
          const statusText = item.status === 'Въехал в точку А'
                    ? 'Въехал в Кара-Кече'
                    : item.status === 'Въехал в точку Б'
                      ? 'Въехал в Базу'
                      : item.status;

          return (
            <div key={item.id} className={styles.loadCard} style={isFar ? {borderLeft: '4px solid #dc3545'} : (hours > 60 ? {borderLeft: '4px solid #ffc107'} : {})}>
               <div className={styles.loadCardHeader}>
                <div className={styles.vehicleNumberBox}>
                  <div className={styles.vehicleNumber}>{item.vehicle_number || '-'}</div>
                  <div className={styles.vehicleModel}>{item.vehicle_model || '-'}</div>
                </div>
                <div className={styles.statusBadgeCard} data-status="В пути">
                  {statusText}
                </div>
              </div>

              <div className={styles.loadCardBody}>
                {/* Driver */}
                 <div className={styles.infoBlock}>
                  <div className={styles.driverName}>
                    👤 {item.employee_name || 'Не указан'}
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Телефон:</span>
                    <span className={styles.infoValue}>{item.employee_phone || '-'}</span>
                  </div>
                  <div className={styles.infoRow} style={{ marginTop: '8px' }}>
                    <span className={styles.infoLabel}>База назначения:</span>
                    <span style={{ color: '#0d6efd', fontWeight: '700' }}>{item.top_base_name || item.chpp_name || item.private_point_name || '-'}</span>
                  </div>
                </div>

                {/* Timing & Geo Details */}
                <div className={styles.timeGeoBlock}>
                   <div style={{gridColumn: '1 / -1', marginBottom: '8px', fontWeight: 'bold', fontSize: '12px', color: '#6c757d'}}>ВЪЕЗД (КАРА-КЕЧЕ)</div>
                   <div className={styles.timeGeoItem}>
                      <span className={styles.timeGeoLabel}>Время</span>
                      <span className={styles.timeGeoValue}>{item.time_a || '-'}</span>
                   </div>
                   <div className={styles.timeGeoItem} style={{ alignItems: 'flex-end' }}>
                     <div style={{ display: 'flex', gap: '8px' }}>
                        {item.geo_a ? (
                          <>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${item.geo_a}`, '_blank')} className={styles.geoLinkBtn}>📍</button>
                            <button onClick={() => toggleMap(item.id, 'geo_a')} className={styles.mapToggleBtn}>{visibleMaps[`${item.id}-geo_a`] ? '✕' : '🗺️'}</button>
                          </>
                        ) : '-'}
                     </div>
                   </div>
                   
                   {/* Mark Info Entry */}
                   <div className={styles.markedInfoBlock}>
                    <div className={styles.markedTitle}>Отметил въезд</div>
                    <div className={styles.markedName}>{item.guard_name || 'Не указан'}</div>
                    {item.guard_phone && (
                       <div className={styles.markedPhone}>
                         📞 {item.guard_phone}
                       </div>
                    )}
                  </div>

                   {item.geo_a && visibleMaps[`${item.id}-geo_a`] && (
                     <div style={{ gridColumn: '1 / -1', height: '150px', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
                       <MiniMap geo={item.geo_a} />
                     </div>
                   )}
                </div>

                <div className={styles.timeGeoBlock} style={{borderBottom: 'none'}}>
                   <div style={{gridColumn: '1 / -1', marginBottom: '8px', fontWeight: 'bold', fontSize: '12px', color: '#6c757d'}}>ВЫЕЗД (КАРА-КЕЧЕ)</div>
                   <div className={styles.timeGeoItem}>
                      <span className={styles.timeGeoLabel}>Время</span>
                      <span className={styles.timeGeoValue}>{item.time_a_exit || '-'}</span>
                   </div>
                   <div className={styles.timeGeoItem} style={{ alignItems: 'flex-end' }}>
                     <div style={{ display: 'flex', gap: '8px' }}>
                        {item.geo_a_exit ? (
                          <>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${item.geo_a_exit}`, '_blank')} className={styles.geoLinkBtn}>📍</button>
                            <button onClick={() => toggleMap(item.id, 'geo_a_exit')} className={styles.mapToggleBtn}>{visibleMaps[`${item.id}-geo_a_exit`] ? '✕' : '🗺️'}</button>
                          </>
                        ) : '-'}
                     </div>
                   </div>
                   
                   {/* Mark Info Exit */}
                   <div className={styles.markedInfoBlock}>
                    <div className={styles.markedTitle}>Отметил выезд</div>
                    <div className={styles.markedName}>{item.exit_guard_name || 'Не указан'}</div>
                    {item.exit_guard_phone && (
                       <div className={styles.markedPhone}>
                         📞 {item.exit_guard_phone}
                       </div>
                    )}
                  </div>

                    {item.geo_a_exit && visibleMaps[`${item.id}-geo_a_exit`] && (
                     <div style={{ gridColumn: '1 / -1', height: '150px', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
                       <MiniMap geo={item.geo_a_exit} />
                     </div>
                   )}
                </div>

                {/* Duration */}
                <div style={{ background: '#f8f9fa', padding: '10px', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <span className={styles.infoLabel}>Время в пути (текущее):</span>
                    <span style={{ fontWeight: '700', color: hours > 60 ? '#dc3545' : '#198754' }}>
                      {item.time_a_exit ? formatDuration(item.time_a_exit, nowTime) : '-'}
                    </span>
                </div>

                {/* Loading time */}
                <div style={{ padding: '0 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                   <span className={styles.infoLabel}>Длительность погрузки:</span>
                   <span className={styles.infoValue}>{item.duration_str_loading || '-'}</span>
                </div>

                {/* Remarks & Guards - REMOVED guardBlock since moved up */}

              </div>
              
              <div className={styles.loadCardFooter}>
                 <div className={styles.notes} title={item.notes || 'Нет примечаний'}>
                   📝 {item.notes || 'Нет примечаний'}
                 </div>
              </div>

            </div>
          );
        })}
      </div>

      <Pagination
        page={inRoutePage}
        setPage={setInRoutePage}
        count={inRouteCount}
        hasNext={!!inRouteNext}
        hasPrev={!!inRoutePrev}
        shownCount={inRouteLoads.length}
        style={{ marginTop: '8px', marginBottom: 0 }}
      />
    </div>
  );
};

export default React.memo(InRouteTableView);
